import { useEffect, useState } from "react";

export default function useRemoteAssets(token?: string) {
  const [assets, setAssets] = useState<any | null>(null);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const mod: any = await import("remote_app/assets");

        const getAssetsFn: any =
          mod.getAssets || mod.default?.getAssets || (typeof mod === "function" ? mod : undefined);

        if (typeof getAssetsFn === "function") {
          const a = getAssetsFn(token);
          if (mounted) setAssets(a);
          return;
        }

        if (mod && typeof mod === "object") {
          if (mounted) setAssets(mod);
          return;
        }

        if (mounted) setAssets(null);
      } catch (err) {
        console.error("Failed to load remote assets:", err);
        if (mounted) setAssets(null);
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, [token]);

  return assets;
}
